import { render, staticRenderFns } from "./setupPassword.vue?vue&type=template&id=86d9690a"
import script from "./setupPassword.vue?vue&type=script&lang=js"
export * from "./setupPassword.vue?vue&type=script&lang=js"
import style0 from "./setupPassword.vue?vue&type=style&index=0&id=86d9690a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86d9690a')) {
      api.createRecord('86d9690a', component.options)
    } else {
      api.reload('86d9690a', component.options)
    }
    module.hot.accept("./setupPassword.vue?vue&type=template&id=86d9690a", function () {
      api.rerender('86d9690a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/setupPassword.vue"
export default component.exports